module.exports = __webpack_public_path__ + "img/start1.d50c9354.png";